import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RecurringTaskSlotComponent } from './recurring-task-slot/recurring-task-slot.component';
import { MinsToDatePipe, MinsToTimePipe } from './minsToTime.pipe';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { RecurringTaskComponent } from './recurring-task.component';

@NgModule({
  declarations: [
    RecurringTaskComponent,
    RecurringTaskSlotComponent,
    MinsToTimePipe,
    MinsToDatePipe
  ],
  providers: [],
  imports: [
    NzTimePickerModule,
    CommonModule,
    NzInputModule,
    NzInputNumberModule,
    ReactiveFormsModule,
    NzDatePickerModule,
    NzFormModule,
    NzGridModule,
    FormsModule,
    NzIconModule,
    NzToolTipModule,
    NzCheckboxModule,
    NzDividerModule,
    NzTableModule,
    NzButtonModule,
    NzPageHeaderModule,
    NgJsonEditorModule
  ],
  exports: [RecurringTaskComponent]
})
export class RecurringTaskScheduleModule {}
